(function () {
  'use strict';

  angular.module('ringbaPortal').component('affiliatePayouts', {
    bindings: {
      payoutsContainerSelector: '@',
      selectedAffiliate: '<',
      campaignId: '<',
      isNewPayoutAdded: '<',
      campaignPayouts: '<',
      scrollToCampaignPayouts: '&', // Function to scroll to campaign payouts panel
      onSave: '&'
    },
    controller: AffiliatePayoutsController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/add-affiliate/affiliate-payouts/affiliate-payouts.view.html'
  });

  function AffiliatePayoutsController(
    $filter,
    $translate,
    accountsService,
    campaignAffiliateService,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.batchUpdatePayoutSettings = batchUpdatePayoutSettings;
    vm.onPayoutSave = onPayoutSave;

    function onInit() {
      vm.payoutSaveConfirmation = $filter('translate')('PUBLISHER_OVERRIDE_PAYOUT_CHANGE_CONFIRM', {
        publisherName: vm.selectedAffiliate.name
      });
      vm.notifyPubLabel = $filter('translate')('PUBLISHER_OVERRIDE_PAYOUT_CHANGE_NOTIFY', {
        publisherName: vm.selectedAffiliate.name
      });
      vm.updatePayoutButtonText = $filter('translate')('PUBLISHER_PAYOUT_UPDATE_BUTTON');
      vm.unsavedChangesText = $filter('translate')('PUBLISHER_PAYOUT_UNSAVED_CHANGES');
      if (!vm.isNewPayoutAdded) {
        _loadPayoutSettings();
      }
    }

    function onPayoutSave() {
      _loadPayoutSettings();
      vm.onSave({
        affiliate: vm.selectedAffiliate
      });
    }

    function batchUpdatePayoutSettings(payoutSettings, notifyPublishers) {
      return campaignAffiliateService.batchUpdatePayoutSettings(accountsService.currentAccountId, vm.campaignId, vm.selectedAffiliate.id, payoutSettings, notifyPublishers)
        .then(function () {
          let message = 'PUBLISHER_OVERRIDE_PAYOUT_CHANGE_NOTIFY_SUCCESS';
          if (!notifyPublishers) {
            message = 'PUBLISHER_OVERRIDE_PAYOUT_CHANGE_NOT_NOTIFY_SUCCESS';
          }
          // A toast title renders as text, so the name goes in unescaped.
          toaster.pop('success', $translate.instant(message, { publisherName: vm.selectedAffiliate.name }, undefined, undefined, null));
          return vm.onSave({
            affiliate: vm.selectedAffiliate
          });
        })
        .catch(utils.errorHandler)
        .finally(_loadPayoutSettings);
    }

    function _loadPayoutSettings() {
      campaignAffiliateService.getAffiliatePayoutSettings(accountsService.currentAccountId, vm.campaignId, vm.selectedAffiliate.id).then(function (response) {
        vm.affiliatePayoutSettings = response.data.payoutSettings;
      }).catch(utils.errorHandler);
    }

  }

})();
